export default __webpack_public_path__ + "static/aws-openai-soc-3cbfd6f844809bdbb0383d8225a30fdf.jpg";